module.exports = __webpack_public_path__ + "static/media/video3.db5bb54c.mp4";